var levelMeta = [
	{
		category: 1,
		categoryName: 'Ingen risiko',
		title: 'Du er helt uten risiko.',
		titleHtml: `Du er helt <span class="color--primary">uten risiko</span>.`,
		intro: `<p>Det finnes ikke noe alkoholkonsum som er helt risikofritt, bortsett fra å la helt være å drikke alkohol. Du som ikke drikker, er altså uten risiko. </p>
		<p>Ca 15 prosent av alle i Norge som er over 16 år drikker ikke alkohol i det hele tatt (kilde FHI). Du er en av dem!  </p>
		`,
		link: {
			text: 'Husk at barn kan reagere på alkoholbruk, før du selv merker det.',
			url: 'https://avogtil.no/artikler/hvorfor-bor-du-tenke-deg-om-for-du-drikker-foran-barn-og-unge/',
		},
		icons: [
			{
				name: 'Oppstemt',
				icon: 'excited',
			},
			{
				name: 'Dårligere konsentrasjon',
				icon: 'badconcentration',
			},
			{
				name: 'Impulsiv',
				icon: 'impulsive',
			},
		],
	},
	{
		category: 2,
		categoryName:'Lav risiko',
		title: 'Du har alkoholvaner med lav risiko.',
		titleHtml: `Du har alkoholvaner med <span class="color--primary">lav risiko</span>.`,
		intro: `<p>Dine drikkevaner innebærer lav risiko for skadelige konsekvenser.</p>
		<p>Ca. 68 prosent av alle i Norge som drikker alkohol, drikker med lav risiko. Akkurat som deg. (kilde FHI) </p>
		`,
		icons: [
			{
				name: 'Dårligere balanse',
				icon: 'badbalance',
			},
			{
				name: 'Lengre reaksjonstid',
				icon: 'slowreaction',
			},
			{
				name: 'Risikovillig',
				icon: 'risky',
			},
		],
	},
	{
		category: 3,
		title: 'Du har alkoholvaner som medfører en viss risiko.',
		titleHtml: `Du har alkoholvaner som medfører <span class="color--primary">en viss risiko</span>.`,
		categoryName: 'Risikofylt bruk',
		intro: `<p>Drikkevanene dine øker risikoen for at du skader deg eller kan på sikt ha negative konsekvenser på livet ditt – fysisk, psykisk eller sosialt.</p>
		<p>Ca. 83 prosent av alle i Norge som drikker alkohol drikker med lavere risiko enn deg (kilde FHI).</p>
`,
		link: {
			text: '8 råd for å begrense promillen',
			url: 'https://avogtil.no/artikler/8-rad-for-a-begrense-promillen/',
		},
		icons: [
			{
				name: 'Sløv',
				icon: 'slow',
			},
			{
				name: 'Snøvlete',
				icon: 'badpronounciation',
			},
			{
				name: 'Sjanglete',
				icon: 'worsebalance',
			},
		],
	},
	{
		category: 4,
		categoryName: 'Skadelig bruk',
		title: 'Du har et skadelig alkoholforbruk.',
		titleHtml: `Du har <span class="color--primary">et skadelig alkoholforbruk</span>.`,
		intro: `<p>Drikkingen din påvirker livet ditt negativt – psykisk eller sosialt – og kan gi deg alvorlige fysiske konsekvenser.</p>
		<p>Du tar skade av drikkingen din.</p>
`,
		icons: [
			{
				name: 'Kvalme og oppkast',
				icon: 'sick',
			},
			{
				name: 'Hukommelses&shy;problemer',
				icon: 'badmemory',
			},
			{
				name: 'Søvnig',
				icon: 'sleepy',
			},
		],
	},
	{
		category: 5,
		categoryName: 'Skadelig bruk og tegn på avhengighet',
		title: 'Du har et skadelig alkoholforbruk og viser tegn på avhengighet.',
		titleHtml: `Du har <span class="color--primary">et skadelig alkoholforbruk</span> og viser <span class="color--primary">tegn på avhengighet</span>.`,
		intro: `<p>Drikkingen din påvirker livet ditt negativt – både psykisk og sosialt – og kan gi alvorlige fysiske konsekvenser.</p>
		<p>Du viser også tegn på avhengighet. Avhengighet kan føre til at du ikke lenger klarer å bestemme hvor mye du vil drikke.</p>
		<p>Du tar skade av drikkingen din.</p>
		`,
		icons: [
			{
				name: 'Svært dårlig kroppskontroll',
				icon: 'lackmoreselfcontrol',
			},
			{
				name: 'Manglende selvkontroll',
				icon: 'lackselfcontrol',
			},
			{
				name: 'Kvalme og oppkast',
				icon: 'sicker',
			},
			// {
			// 	name: 'Risiko for bevisstløshet',
			// 	icon: 'unconscious',
			// },
			// {
			// 	name: 'Risiko for pustestans',
			// 	icon: 'nobreath',
			// },
		],
	},
];

export default levelMeta;